import {
  CubeIcon,                 // Component
  PhotoIcon,                // Image
  VideoCameraIcon,          // Video
  DocumentIcon,             // File
} from '@heroicons/react/24/outline';

// Custom icon for Hero (monitor/screen with stand)
const HeroIcon = (props) => (
  <svg {...props} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M20 1C21.6569 1 23 2.34315 23 4V14C23 15.6569 21.6569 17 20 17H13.562L18.6402 21.2318C19.0645 21.5853 19.1218 22.2159 18.7682 22.6402C18.4147 23.0645 17.7841 23.1218 17.3598 22.7682L13 19.135V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V19.135L6.64018 22.7682C6.21591 23.1218 5.58534 23.0645 5.23178 22.6402C4.87821 22.2159 4.93554 21.5853 5.35982 21.2318L10.438 17H4C2.34315 17 1 15.6569 1 14V4C1 2.34315 2.34315 1 4 1H20ZM20 3C20.5523 3 21 3.44772 21 4V14C21 14.5523 20.5523 15 20 15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H20Z"></path>
  </svg>
);

// Custom icon for Title (large "T" typography)
const TitleIcon = (props) => (
  <svg {...props} viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M46.5,0v139.6h23.3c0-23.3,0-69.8,23.3-93.1c23.2-23.3,46.5-23.3,69.8-23.3h46.5v395.6c0,34.9-11.6,69.8-46.5,69.8l-22.8,0 l-0.5,23.2h232.7v-23.3h-23.3c-34.9,0-46.5-34.9-46.5-69.8V23.3h46.5c23.3,0,46.5,0,69.8,23.3s23.3,69.8,23.3,93.1h23.3V0H46.5z"></path>
  </svg>
);

// Custom icon for Text (paragraph with "A")
const TextIcon = (props) => (
  <svg {...props} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M2,12H5a1,1,0,0,0,0-2H4.635l.586-1.692H8.779L9.365,10H9a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2h-.518L8.945,2.673A1,1,0,0,0,8,2H6a1,1,0,0,0-.945.673L2.518,10H2a1,1,0,0,0,0,2ZM6.712,4h.576l.8,2.308H5.913ZM23,4a1,1,0,0,1-1,1H15a1,1,0,0,1,0-2h7A1,1,0,0,1,23,4Zm0,6a1,1,0,0,1-1,1H15a1,1,0,0,1,0-2h7A1,1,0,0,1,23,10Zm0,5a1,1,0,0,1-1,1H2a1,1,0,0,1,0-2H22A1,1,0,0,1,23,15Zm0,6a1,1,0,0,1-1,1H2a1,1,0,0,1,0-2H22A1,1,0,0,1,23,21Z"></path>
  </svg>
);

// Custom icon for Button (rounded rectangle)
const ButtonIcon = (props) => (
  <svg {...props} viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 5H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm1 7c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v5z"></path>
  </svg>
);

// Custom icon for Button Collection (three stacked buttons)
const ButtonCollectionIcon = (props) => (
  <svg {...props} viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    {/* Top button */}
    <g transform="translate(0, -1.5) scale(1, 0.6)">
      <path d="M17 5H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm1 7c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v5z"></path>
    </g>
    {/* Middle button */}
    <g transform="translate(0, 3.5) scale(1, 0.6)">
      <path d="M17 5H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm1 7c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v5z"></path>
    </g>
    {/* Bottom button */}
    <g transform="translate(0, 8.5) scale(1, 0.6)">
      <path d="M17 5H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm1 7c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v5z"></path>
    </g>
  </svg>
);

export const ELEMENT_ICONS = {
  hero: HeroIcon,
  title: TitleIcon,
  text: TextIcon,
  button: ButtonIcon,
  button_collection: ButtonCollectionIcon,
  component: CubeIcon,
  image: PhotoIcon,
  video: VideoCameraIcon,
  file: DocumentIcon,
};
